<template>
  <div :class="classes">
    <span class="text-sm">{{ label }}</span>
    <button @click="$emit('close')" class="p-0.5 hover:bg-blue-200 hover:cursor-pointer rounded" v-if="isCloseable">
      <XMarkIcon class="size-4"/>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/solid'

const { isCloseable, isClickable } = defineProps<{
  readonly label: any;
  readonly isCloseable?: boolean;
  readonly isClickable?: boolean;
}>();

defineEmits<{
  close: [void];
}>();

const classes = computed(() => {
  let classes = ["flex", "items-center", "gap-x-1.5", "text-center", "justify-center", "rounded-md", "bg-blue-100", "py-0.5", "font-medium", "text-blue-700"];

  if (isClickable) {
    classes = [...classes, "hover:cursor-pointer", "hover:bg-blue-700", "hover:text-white"];
  }

  if (isCloseable) {
    classes = [...classes, "pl-2", "pr-1"];
  } else {
    classes = [...classes, "px-2"];
  }

  return classes;
});
</script>